import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { EntitySyncStatus } from '@/types/accounting-sync';

/**
 * Drill-down query for a single accounting-synced entity (spec §15.1, §17.3).
 *
 * Hits `GET /settings/accounting/sync/entity/:type/:id`. Returns the current
 * sync status, external provider id, last error, retry count, and the most
 * recent sync log attempts (history) for the entity.
 *
 * Disabled until both `type` and `id` are known so we don't fire empty calls
 * when the drawer is closed.
 */
export function useAccountingEntitySyncStatus(
  type: string | null | undefined,
  id: string | null | undefined,
) {
  const enabled = Boolean(type && id);
  return useApiQuery<EntitySyncStatus>({
    queryKey: enabled ? settingsKeys.accountingEntity(type as string, id as string) : ['noop'],
    queryFn: () =>
      apiGet<EntitySyncStatus>(
        operationsClient,
        settingsEndpoints.accountingSyncEntityStatus(type as string, id as string),
      ),
    enabled,
    showErrorToast: false,
  });
}
